import sectionFreestyleCss from '../css-snippets/section-freestyle';

const html = `
<style>${sectionFreestyleCss}</style>
<div
  data-attribute="wrap-content"
  data-top-padding="true"
  data-bottom-padding="true"
  data-layout-full-width="false"
  data-spacing-horizontal="true"
>
  <div class="container" data-attribute="content">
    <p style="text-align: center">
      <strong>🔥Summer Sale-👡Women's Luxurious Orthopedic Sneakers</strong>
    </p>
    <figure class="image image_resized" style="width: 100%">
      <img
        src="https://cdn.cacheimg.com/Admin-Lattehub/2025/08/09/image-6896b5e6373dcdb753425e3e.jpg?w=1000"
      />
    </figure>
    <p style="text-align: center">
      <span
        style="
          background-color: hsl(0, 0%, 100%);
          color: rgb(0, 0, 0);
          font-family: Georgia, serif;
        "
        >Designed by professional podiatrists &amp; professional shoemakers,
        orthopedic cushion</span
      ><br /><span
        style="
          background-color: hsl(0, 0%, 100%);
          color: rgb(0, 0, 0);
          font-family: Georgia, serif;
        "
        >sneakers Corrects Posture &amp; Eliminates Muscle Imbalances By Moving
        Angled Toes</span
      ><br /><span
        style="
          background-color: hsl(0, 0%, 100%);
          color: rgb(0, 0, 0);
          font-family: Georgia, serif;
        "
        >Back To Its Original Position To Realign Skeleton Positioning.</span
      >
    </p>
  </div>
</div>
`;
export default html;
